import script from "./Domain.vue?vue&type=script&setup=true&lang=js"
export * from "./Domain.vue?vue&type=script&setup=true&lang=js"

import "./Domain.vue?vue&type=style&index=0&id=31a5cf50&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a5cf50"]])

export default __exports__